import { useTheme } from "../../../theme/ThemeProvider";
import { ILayoutStyles } from "../../index";
import { ITheme } from "../../../theme/ITheme";
import { useConfigurationStyles, useControlStyles, useDrawerStyles, useEnvironmentBarStyles, useFormStyles, useHeaderStyles, usePageStyles, useProfileStyles, useSearchStyles, useSectionStyles ,useSideNavStyles} from ".";


export const useLayoutStyles = (): ILayoutStyles => {
    const theme: ITheme = useTheme();

    return {
        configuration: useConfigurationStyles(theme),
        control: useControlStyles(theme),
        drawer: useDrawerStyles(theme),
        environmentBar: useEnvironmentBarStyles(theme),
        form: useFormStyles(theme),
        header: useHeaderStyles(theme),
        page: usePageStyles(theme),
        profile: useProfileStyles(theme),
        search: useSearchStyles(theme),
        section: useSectionStyles(theme),
        sideNav: useSideNavStyles(theme),
        
        contentContainer: {
            width: "100%",
            backgroundColor: theme.palette.background.light,
        },
        mainContainer: {
            height: "100vh"
        },
    };
};

